import { render } from "./SubjectsList.vue?vue&type=template&id=ec5f4b50&ts=true"
import script from "./SubjectsList.ts?vue&type=script&lang=ts"
export * from "./SubjectsList.ts?vue&type=script&lang=ts"

import "./SubjectsList.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__